import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e9210d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-container" }
const _hoisted_2 = { class: "admin-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Content Management", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Admin Login", -1))
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password:", -1))
const _hoisted_7 = { class: "form-actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn-primary"
}, "Login", -1))
const _hoisted_9 = {
  key: 0,
  class: "error-message"
}
const _hoisted_10 = {
  key: 1,
  class: "admin-content"
}
const _hoisted_11 = { class: "tabs" }
const _hoisted_12 = { class: "tab-content" }
const _hoisted_13 = {
  key: 0,
  class: "content-section"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Common Content", -1))
const _hoisted_15 = {
  key: 0,
  class: "form-grid"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Title:", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Intro Text:", -1))
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Category Lead:", -1))
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Questions Lead:", -1))
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Result Header:", -1))
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Image URL:", -1))
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Image Alt Text:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "Response Labels", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Response Yes:", -1))
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Response No:", -1))
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Response Don't Know:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "Button Labels", -1))
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Button Back:", -1))
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Button Next:", -1))
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Button Go to Questions:", -1))
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Button Show Results:", -1))
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Button Start Here:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "Other Labels", -1))
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Category Prefix:", -1))
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Read More:", -1))
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Hide:", -1))
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Question:", -1))
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Choose an Answer:", -1))
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Choose an Option:", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "Error Messages", -1))
const _hoisted_62 = { class: "form-group" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "There Are Problems:", -1))
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Problems Detected:", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "Result Page Labels", -1))
const _hoisted_67 = { class: "form-group" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Result Response Title:", -1))
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Result Response Lead:", -1))
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Result Extra Categories Title:", -1))
const _hoisted_73 = { class: "form-group" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Result Extra Categories Text:", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "PDF Labels", -1))
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "PDF Result Title:", -1))
const _hoisted_78 = { class: "form-group" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "PDF Category Prefix:", -1))
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "PDF Question Prefix:", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"2rem","margin-bottom":"1rem"} }, "Download Labels", -1))
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Download All Categories:", -1))
const _hoisted_85 = { class: "form-group" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Download Result for Category:", -1))
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Download Result:", -1))
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Building PDF:", -1))
const _hoisted_91 = {
  key: 1,
  class: "content-section"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Categories", -1))
const _hoisted_93 = {
  key: 0,
  class: "categories-list"
}
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "toggle-icon" }
const _hoisted_96 = {
  key: 0,
  class: "category-content"
}
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Title:", -1))
const _hoisted_99 = ["onUpdate:modelValue"]
const _hoisted_100 = { class: "form-group" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Intro:", -1))
const _hoisted_102 = ["onUpdate:modelValue"]
const _hoisted_103 = { class: "form-group" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description:", -1))
const _hoisted_105 = ["onUpdate:modelValue"]
const _hoisted_106 = { class: "form-group" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "PDF Header:", -1))
const _hoisted_108 = ["onUpdate:modelValue"]
const _hoisted_109 = { class: "form-group" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "PDF Footer:", -1))
const _hoisted_111 = ["onUpdate:modelValue"]
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Questions", -1))
const _hoisted_113 = { class: "form-group" }
const _hoisted_114 = ["onUpdate:modelValue"]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin-top":"1rem","margin-bottom":"0.5rem"} }, "Response Feedback:", -1))
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = ["onUpdate:modelValue"]
const _hoisted_118 = { class: "admin-actions" }
const _hoisted_119 = ["disabled"]
const _hoisted_120 = {
  key: 2,
  class: "auth-required"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please login to access the admin interface.", -1))
const _hoisted_122 = [
  _hoisted_121
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLoginDialog = true))
          }, "Login"))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, "Logout"))
    ]),
    (_ctx.showLoginDialog)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "dialog-overlay",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showLoginDialog = false))
        }, [
          _createElementVNode("div", {
            class: "dialog-content",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, [
            _hoisted_4,
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginPassword) = $event)),
                  type: "password",
                  required: "",
                  autofocus: ""
                }, null, 512), [
                  [_vModelText, _ctx.loginPassword]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-secondary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLoginDialog = false))
                }, "Cancel")
              ]),
              (_ctx.loginError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.loginError), 1))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: _normalizeClass(['tab', { active: _ctx.activeTab === 'common' }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeTab = 'common'))
            }, "Common Content", 2),
            _createElementVNode("button", {
              class: _normalizeClass(['tab', { active: _ctx.activeTab === 'categories' }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeTab = 'categories'))
            }, "Categories", 2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.activeTab === 'common')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  (_ctx.content)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.content.common.title) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.title]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.content.common.introText) = $event)),
                            rows: "4"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.introText]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.content.common.categoryLead) = $event)),
                            rows: "3"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.categoryLead]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.content.common.questionsLead) = $event)),
                            rows: "3"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.questionsLead]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.content.common.resultHeader) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.resultHeader]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.content.common.image.url) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.image.url]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.content.common.image.alt) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.image.alt]
                          ])
                        ]),
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.content.common.responseYes) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.responseYes]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.content.common.responseNo) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.responseNo]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.content.common.responseDontKnow) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.responseDontKnow]
                          ])
                        ]),
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.content.common.buttonBack) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.buttonBack]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.content.common.buttonNext) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.buttonNext]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.content.common.buttonGoToQuestions) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.buttonGoToQuestions]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.content.common.buttonShowResults) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.buttonShowResults]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.content.common.buttonStartHere) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.buttonStartHere]
                          ])
                        ]),
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, [
                          _hoisted_50,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.content.common.categoryPrefix) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.categoryPrefix]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.content.common.readMore) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.readMore]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _hoisted_54,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.content.common.hide) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.hide]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.content.common.question) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.question]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.content.common.chooseAnAnswer) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.chooseAnAnswer]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.content.common.chooseAnOption) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.chooseAnOption]
                          ])
                        ]),
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.content.common.thereAreProblems) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.thereAreProblems]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.content.common.problemsDetected) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.problemsDetected]
                          ])
                        ]),
                        _hoisted_66,
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.content.common.resultResponseTitle) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.resultResponseTitle]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.content.common.resultResponseLead) = $event)),
                            rows: "3"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.resultResponseLead]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _hoisted_72,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.content.common.resultExtraCategoriesTitle) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.resultExtraCategoriesTitle]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                          _hoisted_74,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.content.common.resultExtraCategoriesText) = $event)),
                            rows: "3"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.resultExtraCategoriesText]
                          ])
                        ]),
                        _hoisted_75,
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.content.common.pdfResultTitle) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.pdfResultTitle]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _hoisted_79,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.content.common.pdfCategoryPrefix) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.pdfCategoryPrefix]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _hoisted_81,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.content.common.pdfQuestionPrefix) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.pdfQuestionPrefix]
                          ])
                        ]),
                        _hoisted_82,
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.content.common.downloadAllCategories) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.downloadAllCategories]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.content.common.downloadResultForCategory) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.downloadResultForCategory]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_87, [
                          _hoisted_88,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.content.common.downloadResult) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.downloadResult]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.content.common.buildingPdf) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.content.common.buildingPdf]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'categories')
              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                  _hoisted_92,
                  (_ctx.content)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.categories, (category) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: category.id,
                            class: "category-item"
                          }, [
                            _createElementVNode("div", {
                              class: "category-header",
                              onClick: ($event: any) => (_ctx.toggleCategory(category.id))
                            }, [
                              _createElementVNode("h3", null, _toDisplayString(category.title), 1),
                              _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.expandedCategories.has(category.id) ? '▼' : '▶'), 1)
                            ], 8, _hoisted_94),
                            (_ctx.expandedCategories.has(category.id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                  _createElementVNode("div", _hoisted_97, [
                                    _hoisted_98,
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((category.title) = $event),
                                      type: "text"
                                    }, null, 8, _hoisted_99), [
                                      [_vModelText, category.title]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_100, [
                                    _hoisted_101,
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": ($event: any) => ((category.intro) = $event),
                                      rows: "3"
                                    }, null, 8, _hoisted_102), [
                                      [_vModelText, category.intro]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_103, [
                                    _hoisted_104,
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": ($event: any) => ((category.description) = $event),
                                      rows: "4"
                                    }, null, 8, _hoisted_105), [
                                      [_vModelText, category.description]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_106, [
                                    _hoisted_107,
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((category.pdfHeader) = $event),
                                      type: "text"
                                    }, null, 8, _hoisted_108), [
                                      [_vModelText, category.pdfHeader]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _hoisted_110,
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((category.pdfFooter) = $event),
                                      type: "text"
                                    }, null, 8, _hoisted_111), [
                                      [_vModelText, category.pdfFooter]
                                    ])
                                  ]),
                                  _hoisted_112,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.questions, (question, qIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: qIndex,
                                      class: "question-item"
                                    }, [
                                      _createElementVNode("div", _hoisted_113, [
                                        _createElementVNode("label", null, "Question " + _toDisplayString(qIndex + 1) + ":", 1),
                                        _withDirectives(_createElementVNode("textarea", {
                                          "onUpdate:modelValue": ($event: any) => ((question.text) = $event),
                                          rows: "2"
                                        }, null, 8, _hoisted_114), [
                                          [_vModelText, question.text]
                                        ])
                                      ]),
                                      _hoisted_115,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.responses, (response, rIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: rIndex,
                                          class: "response-item"
                                        }, [
                                          _createElementVNode("div", _hoisted_116, [
                                            _createElementVNode("label", null, _toDisplayString(response.label) + " Feedback:", 1),
                                            _withDirectives(_createElementVNode("textarea", {
                                              "onUpdate:modelValue": ($event: any) => ((response.feedback) = $event),
                                              rows: "4"
                                            }, null, 8, _hoisted_117), [
                                              [_vModelText, response.feedback]
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("button", {
              disabled: _ctx.saving,
              class: "btn-primary btn-large",
              onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.saveContent && _ctx.saveContent(...args)))
            }, _toDisplayString(_ctx.saving ? 'Saving...' : 'Save All Changes'), 9, _hoisted_119),
            (_ctx.saveMessage)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(['message', _ctx.saveMessageType])
                }, _toDisplayString(_ctx.saveMessage), 3))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_120, _hoisted_122))
  ]))
}